import React from 'react';

import Loading from './components/loading.component'
import LoadingMobile from './componentsMobile/loading.component';

//import mobileAndTabletCheck from './utils/mobileCheck';

interface Props {}

interface State {
  isMobile: boolean
}

class App extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      isMobile: false
    }
  }

  componentDidMount(): void {
    var check = window.innerHeight > window.innerWidth
    this.setState({
      isMobile: check
    })
    window.addEventListener("resize", () => {
      var currentSize = this.state.isMobile
      this.setState({
        isMobile:
          window.innerHeight > window.innerWidth,
      }, () => {
        if(currentSize !== this.state.isMobile){
          window.location.reload()
        }
      });
    });
  }

  render(): React.ReactNode {
      return(
        <div className='interactive-car-container'>
          {
            !this.state.isMobile ?
            <Loading/>:
            <LoadingMobile/>
          }
        </div>
      )
  }
}

export default App
